import { createKiddoAxios } from "./httpClient";

let apiPromise;

const getLeaderboardApi = async () => {
  if (!apiPromise) {
    apiPromise = (async () => {
      const instance = await createKiddoAxios({ timeout: 10000 });

      instance.interceptors.request.use(
        (config) => config,
        (error) => Promise.reject(error)
      );

      instance.interceptors.response.use(
        (response) => response,
        (error) => {
          console.error('API Error:', error.response?.data || error.message);
          return Promise.reject(error);
        }
      );

      return instance;
    })();
  }
  return apiPromise;
};

const normalizeLeaderboardParams = (input) => {
  if (typeof input === "number") return { top: input };
  if (input && typeof input === "object") return input;
  return {};
};

const buildLeaderboardParams = (options) => {
  const { top = 10, subjectId, gradeId, quizGuid } = normalizeLeaderboardParams(options);
  const params = { top };
  if (subjectId !== undefined && subjectId !== null && subjectId !== "") {
    params.subjectId = subjectId;
  }
  if (gradeId !== undefined && gradeId !== null && gradeId !== "") {
    params.gradeId = gradeId;
  }
  if (quizGuid !== undefined && quizGuid !== null && quizGuid !== "") {
    params.quizGuid = quizGuid;
  }
  return params;
};

export const GlobalAllTimeLeaderboard = async (options) => {
  try {
    const api = await getLeaderboardApi();
    const params = buildLeaderboardParams(options);
    const response = await api.get(`/Read/AllTimeLeaderboard`, { params });
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch global leaderboard: ${error.message}`);
  }
};

export const AllTimeLeaderboard = async (options) => {
  return GlobalAllTimeLeaderboard(options);
};

export const WeeklyLeaderboard = async (options) => {
  try {
    const api = await getLeaderboardApi();
    const params = buildLeaderboardParams(options);
    const response = await api.get(`/read/WeeklyLeaderboard`, { params });
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch weekly leaderboard: ${error.message}`);
  }
};

export const LeaderboardByUserId = async (studentId, options = {}) => {
  try {
    if (!studentId) {
      throw new Error('Student ID is required');
    }
    const api = await getLeaderboardApi();
    const params = { studentId };
    const maybequizGuid =
      typeof options === 'string'
        ? options
        : options && typeof options === 'object'
          ? options.quizGuid
          : undefined;

    if (maybequizGuid !== undefined && maybequizGuid !== null && maybequizGuid !== '') {
      params.quizGuid = maybequizGuid;
    }

    const response = await api.get(`/read/leaderboardbystudentid`, { params });
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch user leaderboard: ${error.message}`);
  }
};
